import { render, staticRenderFns } from "./ConsultaChavePix.vue?vue&type=template&id=32460d45&"
import script from "./ConsultaChavePix.vue?vue&type=script&lang=js&"
export * from "./ConsultaChavePix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports